import { CustomAction } from '..';

export interface Device_Obj {
    quantity: number;
    name: string;
}

export interface Variant_Obj {
    id: string;
    max_users: number;
    price_monthly: number;
    devices: Device_Obj
}

export interface Product_Obj {
    id: string;
    name: string;
    currency: string;
    price_monthly: number;
    feature_list: string[];
    devices: Device_Obj;
    max_users: number;
    company_type: 'XS' | 'S' | 'M' | 'L' | 'XL';
    variants: Variant_Obj[];
}

export interface Product_Actions {
    undefined: Function;
    PRODUCT_LIST_REPLACE: Function;
    PRODUCT_LIST_PUSH: Function;
    PRODUCT_LIST_PUT: Function;
    PRODUCT_LIST_REMOVE: Function;
}

export const actions: Product_Actions = {
    'undefined': (state = null, payload: any) => state,
    PRODUCT_LIST_REPLACE: (state: Product_Obj[], payload: Product_Obj[]) => payload,
    PRODUCT_LIST_PUSH: (state: Product_Obj[], payload: Product_Obj[]) => {

        if (payload != null && state != null) {
            let new_list: Product_Obj[] = [...state];

            if (new_list.length > 0) {
                let new_index: any = {};

                new_list.forEach(new_item => {
                    new_index[new_item.id] = new_item;
                })

                payload.forEach(new_item => {
                    if (new_index[new_item.id] == undefined) {
                        new_list.push(new_item)
                    }
                })
            }

            return new_list.length > 0 ? [...new_list] : []
        } else {
            return state != null ? [...state] : []
        }
    },
    PRODUCT_LIST_PUT: (state: Product_Obj[], payload: Product_Obj) => {

        // new item is null for some reason
        if (payload == null) return state != null ? [...state] : [];

        // old item list starts as empty
        if (state == null) return payload != null ? [payload] : [];

        let new_state: Product_Obj[] = [...state];

        let update_index: number = new_state.findIndex(old_item => old_item.id == payload.id);

        if (update_index > -1) {
            // item is found, update
            new_state[update_index] = Object.assign({}, payload);

            return new_state
        } else {
            new_state.push(payload)

            // item is not found, push
            return new_state
        }
    },
    PRODUCT_LIST_REMOVE: (state: Product_Obj[], payload: string) => {
        if (payload == null) return state != null ? [...state] : [];

        // old item list starts as empty, nothing to remove
        if (state == null) return null;

        let new_state: Product_Obj[] = [...state];

        let remove_index: number = new_state.findIndex(att_item => att_item.id == payload);

        if (remove_index > -1) {
            // item exists

            new_state.splice(remove_index, 1)
        }

        return [...new_state]
    }
};

export function productListReducer (state: Product_Obj[], action: CustomAction): Product_Obj[] | null {
    if (['PRODUCT_LIST_REPLACE', 'PRODUCT_LIST_PUSH', 'PRODUCT_LIST_PUT', 'PRODUCT_LIST_REMOVE'].includes(action.type) && Object.keys(actions).includes(action.type)) return actions[action.type](state, action.payload);

    return state != undefined ? state : null;
}


// WEBPACK FOOTER //
// ./src/store/reducers/product_list.reducers.ts